import GameScene from "../scenes/GameScene";
import { Player } from "./Player";
import { PlayerMovement } from "./PlayerMovement";

export class GameTutorial {
	scene: GameScene;

	player: Player;
	cursors: Phaser.Types.Input.Keyboard.CursorKeys;
	isTutorial1 = true;
	hand: Phaser.GameObjects.Image;
	constructor(scene: GameScene, levelName: string) {
		console.log("gameTutorial()");
		this.scene = scene;
		this.player = this.scene.player;
		if (levelName == "GreenCircle") this.startTutorial1();
		else if (levelName == "BlueSquare") this.startTutorial3();
	}

	startTutorial1(): void {
		//console.log("tutorial1()");
		this.isTutorial1 = true;
		const hand = (this.hand = this.scene.add.image(0, 0, "helpHand"));
		this.cursors = this.player.cursors;
		this.player.add(hand);
		hand.scale = 1 / this.player.scale;
		const offset = { x: 50, y: 25 };
		hand.setPosition(this.player.displayWidth / 5 + offset.x, -this.player.displayHeight / 3 + offset.y);
		hand.angle = -5;

		this.scene.tweens.add({
			targets: hand,
			duration: 750,
			scale: hand.scale * 1.2,
			yoyo: true,
			repeat: -1,
			ease: Phaser.Math.Easing.Quadratic.InOut,
		});

		this.scene.input.once(Phaser.Input.Events.POINTER_DOWN, () => {
			this.dismissHand();
		});
	}
	dismissHand(): void {
		this.scene.tweens.add({
			targets: this.hand,
			alpha: 0,
			duration: 100,
			ease: Phaser.Math.Easing.Quadratic.Out,
			onComplete: this.hand.destroy,
		});
		this.isTutorial1 = false;
		// this.startTutorial2();
		this.endTutorial();
	}
	startTutorial2(): void {
		//console.log("tutorial2()");s
		this.scene.chunkLoader.tutorialLevel++;
		this.player.once(Player.ON_FLAG_COLLECT, this.endTutorial, this);
	}
	startTutorial3(): void {
		//console.log("tutorial3()");
		this.scene.chunkLoader.tutorialLevel = 2;
		const movement = this.player.getComponent(PlayerMovement);
		movement.events.once(PlayerMovement.ON_HIT_GROUND, this.endTutorial, this);
	}
	endTutorial(): void {
		//console.log("endTutorial()");
		this.scene.chunkLoader.tutorial = false;
		this.scene.endTutorial();
	}
}
